import { useNavigate } from "react-router-dom";

import { useSmokeballApp } from "@smart/itops-smokeball-app-dom";
import { toSubdomain } from "@smart/itops-utils-basic";

import {
  builderReminderMessagePath,
  settingsExpandedTabPath,
  settingsTabPath,
} from "./paths";
import { SettingsTabKey } from "./tabs";

// desktop saves window size/position per key across sessions, renaming resets it
const settingsWindowStateKey = "intake.settings";

export const useIntakeSettingsNavigation = () => {
  const { hostType, host } = useSmokeballApp();

  const openWindow = (tab?: SettingsTabKey) => {
    host?.open({
      url: toSubdomain("app", settingsExpandedTabPath(tab)),
      title: "Intake Settings",
      stateKey: settingsWindowStateKey,
    });
  };

  const navigate = (tab?: SettingsTabKey) => {
    if (hostType === "windows" && tab) {
      openWindow(tab);
    } else {
      host?.navigate({ target: "intake-settings", tab });
    }
  };

  return { canOpen: !!host, openWindow, navigate };
};

export const useReviewFormsNavigation = () => {
  const { hostType, host } = useSmokeballApp();
  const routerNavigate = useNavigate();
  const { navigate, canOpen } = useIntakeSettingsNavigation();

  const openBuilder = () => {
    if (hostType === "web") {
      routerNavigate(builderReminderMessagePath("custom", false));
      return;
    }
    host?.navigate({
      target: "intake-form-builder",
      reminderMessage: "custom",
    });
  };

  const backToSettings = () => {
    if (hostType === "web") {
      routerNavigate(settingsTabPath("client-messages"));
      return;
    }
    navigate("client-messages");
  };

  const canNavigate = hostType === "web" || canOpen;

  return {
    canNavigate,
    // desktop users close the Intake Forms window to get back
    canGoBack: canNavigate && hostType !== "windows",
    openBuilder,
    backToSettings,
  };
};
